import { useMedia } from 'tamagui'

import { BASE_FONT_SIZE, LINE_HEIGHT_RATIO, SCALE_RATIO } from '@data/config/fontScale'

// Font line height calculator matching the tamagui config font scale
const LINE_HEIGHT_BASE = BASE_FONT_SIZE * LINE_HEIGHT_RATIO

export function fontLineHeight(level: number): number {
  return LINE_HEIGHT_BASE * Math.pow(SCALE_RATIO, level - 5)
}

// Helper to select values by breakpoint using Tamagui's useMedia
export function selectMediaValue<T>(
  media: ReturnType<typeof useMedia>,
  values: T[]
): T {
  if (values.length >= 5 && media.gtLg) return values[4]
  if (values.length >= 4 && media.gtMd) return values[3]
  if (values.length >= 3 && media.gtSm) return values[2]
  if (values.length >= 2 && media.gtXs) return values[1]
  return values[0]
}
